export const FETCH_AD_PLACEMENT_REQUEST = 'ads/FETCH_AD_PLACEMENT_REQUEST';
export const FETCH_AD_PLACEMENT_SUCCESS = 'ads/FETCH_AD_PLACEMENT_SUCCESS';
export const FETCH_AD_PLACEMENT_FAILURE = 'ads/FETCH_AD_PLACEMENT_FAILURE';

export const TRACK_AD_EVENT_REQUEST = 'ads/TRACK_AD_EVENT_REQUEST';
export const TRACK_AD_EVENT_SUCCESS = 'ads/TRACK_AD_EVENT_SUCCESS';
export const TRACK_AD_EVENT_FAILURE = 'ads/TRACK_AD_EVENT_FAILURE';
